import React from "react";

type Props = {
  className?: string;
};
export const CloseIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 14 14" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1247 1.12473C12.6415 0.641494 11.858 0.641495 11.3748 1.12473L7 5.49951L2.62522 1.12473C2.14198 0.641496 1.35851 0.641495 0.875271 1.12473C0.392038 1.60796 0.392037 2.39144 0.875271 2.87467L5.25005 7.24946L0.875115 11.6244C0.391881 12.1076 0.391881 12.8911 0.875114 13.3743C1.35835 13.8576 2.14183 13.8576 2.62506 13.3743L7 8.9994L11.3749 13.3743C11.8582 13.8576 12.6417 13.8576 13.1249 13.3743C13.6081 12.8911 13.6081 12.1076 13.1249 11.6244L8.74994 7.24946L13.1247 2.87467C13.608 2.39144 13.608 1.60796 13.1247 1.12473Z"
      />
    </svg>
  );
};
